import { request } from "@core-shop/services/api/request";
import { OnboardingInfoData } from "@core-shop/types";
import { getOnboardingInfoQuery } from "./onboardingInfoQuery";

export function getOnboardingInfo() {
  return request<OnboardingInfoData>(getOnboardingInfoQuery);
}
